import React from 'react';
import { connect } from 'react-redux';
import { closeCustomerResourceModal } from 'actions/ui';
import { ModalWindow } from 'ui-core-dashboard';
import { withTranslation } from 'react-i18next';
import Form from './Form';

const mapStateToProps = (state) => ({
    showCustomerResourceModal: state.ui.showCustomerResourceModal,
});

const mapDispatchToProps = (dispatch) => ({
    closeCustomerResourceModal: () => dispatch(closeCustomerResourceModal()),
});


@withTranslation()
@connect(mapStateToProps, mapDispatchToProps)
class CustomerResourceModal extends React.Component {
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
    }

    onClose = () => this.props.closeCustomerResourceModal();

    handleKeyPress = (e) => {
        if (e.keyCode === 27) {
            this.onClose();
        }
    };

    render() {
        const { showCustomerResourceModal, t } = this.props;
        return (
            showCustomerResourceModal && <ModalWindow className="ordering-component-ui-core-wrapper" onClose={this.onClose}>
                <header className="modal-window-header">
                    <div className="modal-window-title">{t('newEntityButton.resources')}</div>
                </header>
                <Form closeModal={this.onClose}/>
            </ModalWindow>
        );
    }
}

export default CustomerResourceModal;
